import React, { useState, useEffect } from "react";
import Speech from "speak-tts";
import './SliderComponent.css';

const ListenTextComponent = ({ param }) => {
  const [selectedLanguage, setSelectedLanguage] = useState("en-US");
  const [rate, setRate] = useState(1.0);
  const [pitch, setPitch] = useState(1.0);
  const [volume, setVolume] = useState(1.0);
  const [isListening, setIsListening] = useState(false);

  const speech = new Speech();

  const handleRateChange = (e) => setRate(parseFloat(e.target.value));
  const handleVolumeChange = (e) => setVolume(parseFloat(e.target.value));
  const handlePitchChange = (e) => setPitch(parseFloat(e.target.value));

  const languageOptions = [
    { code: "en-US", name: "English (United States)" },
    { code: "en-GB", name: "English (United Kingdom)" },
    { code: "en-AU", name: "English (Australia)" },
    { code: "en-CA", name: "English (Canada)" },
    { code: "fr-FR", name: "French (France)" },
    { code: "fr-CA", name: "French (Canada)" },
    { code: "es-ES", name: "Spanish (Spain)" },
    { code: "es-MX", name: "Spanish (Mexico)" },
    { code: "de-DE", name: "German (Germany)" },
    { code: "it-IT", name: "Italian (Italy)" },
    { code: "pt-BR", name: "Portuguese (Brazil)" },
    { code: "pt-PT", name: "Portuguese (Portugal)" },
    { code: "ru-RU", name: "Russian (Russia)" },
    { code: "ja-JP", name: "Japanese (Japan)" },
    { code: "zh-CN", name: "Chinese (Simplified, China)" },
    { code: "zh-TW", name: "Chinese (Traditional, Taiwan)" },
    { code: "ko-KR", name: "Korean (South Korea)" },
    { code: "nl-NL", name: "Dutch (Netherlands)" },
    { code: "sv-SE", name: "Swedish (Sweden)" },
    { code: "no-NO", name: "Norwegian (Norway)" },
    { code: "da-DK", name: "Danish (Denmark)" },
    { code: "fi-FI", name: "Finnish (Finland)" },
    { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
    { code: "hi-IN", name: "Hindi (India)" },
    { code: "bn-BD", name: "Bengali (Bangladesh)" },
    { code: "ta-IN", name: "Tamil (India)" },
    { code: "te-IN", name: "Telugu (India)" },
    { code: "ur-PK", name: "Urdu (Pakistan)" },
    { code: "tr-TR", name: "Turkish (Turkey)" },
    { code: "el-GR", name: "Greek (Greece)" },
  ];

  const handleLanguageChange = (e) => {
    const selectedCode = e.target.value;
    setSelectedLanguage(selectedCode);
  };

  const handleListenNotes = () => {
    if (isListening) {
      speech.cancel();
      setIsListening(false);
    } else {
      setIsListening(true);
      speech.setRate(rate);
      speech.setPitch(pitch);
      speech.setVolume(volume);
      speech.setLanguage(selectedLanguage);
      speech.speak({ text: param });
    }
  };

  useEffect(() => {
    return () => {
      if (isListening) {
        speech.cancel();
        setIsListening(false);
      }
    };
  }, [isListening]);

  return (
    <div className="text-black text-sm bg-blue-200 border-lime-600">
      <div className="mt-2 mb-2 ml-2 mr-2 flex flex-col justify-center text-black">
        <select
          className="mt-4"
          onChange={handleLanguageChange}
          style={{ padding: "5px", marginRight: "5px", border: "1px solid #ccc" }}
        >
          <option value="">Select Output Language</option>
          {languageOptions.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.name}
            </option>
          ))}
        </select>
      </div>
      <div className="slider-container">
        <div className="slider-item">
            <p>Speech Rate: {rate.toFixed(1)}</p>
            <input
            type="range"
            min="0"
            max="2"
            step="0.1"
            value={rate}
            onChange={handleRateChange}
            className="slider"
            />
        </div>
        <div className="slider-item">
            <p>Speech Volume: {volume.toFixed(1)}</p>
            <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={handleVolumeChange}
            className="slider"
            />
        </div>
        <div className="slider-item">
            <p>Speech Pitch: {pitch.toFixed(1)}</p>
            <input
            type="range"
            min="0"
            max="2"
            step="0.1"
            value={pitch}
            onChange={handlePitchChange}
            className="slider"
            />
        </div>
        <div className="slider-item">
            <button
            className="small-button"
            onClick={handleListenNotes}
            style={{
                width: "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            }}
            >
            {isListening ? "Stop" : "Listen"}
            </button>
        </div>
        </div>
    </div>
  );
};

export default ListenTextComponent;
